import React from 'react';
import './ModeToggle.less';

export type DomainMode = 'traditional' | 'ai';

interface IModeToggleProps {
  value: DomainMode;
  onChange: (mode: DomainMode) => void;
  className?: string;
}

const SparkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9-1.9 5.6-1.9-5.6L4.5 10l5.6-1.9L12 2.5z"
      fill="currentColor"
    />
  </svg>
);

/**
 * The signature "Traditional ↔ AI-Accelerated" segmented control. Dropped on
 * top of every domain dashboard so the same outcome can be reached either way.
 */
const ModeToggle: React.FC<IModeToggleProps> = ({ value, onChange, className }) => (
  <div className={`domain-mode-toggle ${className || ''}`} role="tablist">
    <button
      type="button"
      role="tab"
      aria-selected={value === 'traditional'}
      className={`domain-mode-toggle__seg ${value === 'traditional' ? 'is-active' : ''}`}
      onClick={() => onChange('traditional')}
    >
      Traditional
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={value === 'ai'}
      className={`domain-mode-toggle__seg domain-mode-toggle__seg--ai ${
        value === 'ai' ? 'is-active' : ''
      }`}
      onClick={() => onChange('ai')}
    >
      <SparkIcon />
      AI-Accelerated
    </button>
  </div>
);

export default ModeToggle;
